import { OrderLineEffects } from './order-line.effects';
export const effects: any[] = [OrderLineEffects];
